import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
const Vue = createApp(App);
import "element-plus/theme-chalk/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import ElementUI from "element-plus";
Vue.use(ElementUI, {
  locale: zhCn,
});
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
//注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  Vue.component(key, component);
}

// 全局封装类统一注入
import zeedoUtils from "./utils/zeedoUtils";
Vue.use(zeedoUtils);
router.beforeEach(function (to, from, next) {
  if (!!to.meta.title) {
    document.title = to.meta.title;
  }

  if (isMobileDevice()) {
    // 加载移动端代码或跳转到移动端版本
    window.location.href =
      "https://app.zeedo-tech.cn/ZeeDoOfficialWebsiteMobile/#/homePage";
  } else {
    // 加载PC端代码
    next();
  }
});
router.afterEach((to) => {
  if (to.path === "/homePage") {
    window.history.replaceState(null, null, "/");
  }
});

// main.js
// window.addEventListener("resize", function () {
//   if (isMobileDevice()) {
//     // 加载移动端代码或跳转到移动端版本
//     window.location.href =
//       "https://app.zeedo-tech.cn/ZeeDoOfficialWebsiteMobile/#/homePage";
//   }
// });
function isMobileDevice() {
  const userAgent = navigator.userAgent;
  const isMobile = /Mobile|Android|iPhone|iPad/.test(userAgent);
  // const isSmallScreen = window.innerWidth <= 768;

  return isMobile;
}

Vue.use(store).use(router).mount("#app");
